module.exports = __webpack_public_path__ + "img/disability-assist.152e9245.png";